var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.964 7.60637L4.92025 2.10481C4.90185 2.09032 4.87973 2.08131 4.85643 2.07883C4.83314 2.07634 4.80962 2.08048 4.78857 2.09076C4.76752 2.10104 4.7498 2.11704 4.73744 2.13694C4.72508 2.15684 4.71858 2.17982 4.71869 2.20325V3.41106C4.71869 3.48762 4.75463 3.56106 4.814 3.60793L10.439 8.00012L4.814 12.3923C4.75307 12.4392 4.71869 12.5126 4.71869 12.5892V13.797C4.71869 13.9017 4.839 13.9595 4.92025 13.8954L11.964 8.39387C12.0239 8.34717 12.0723 8.28744 12.1056 8.21921C12.1389 8.15098 12.1562 8.07605 12.1562 8.00012C12.1562 7.92419 12.1389 7.84927 12.1056 7.78104C12.0723 7.71281 12.0239 7.65307 11.964 7.60637Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightOutlined);
export default __webpack_public_path__ + "static/media/right-outlined.5370f42bfab01a09feffb8a209bdc726.svg";
export { ForwardRef as ReactComponent };